import { type FC } from 'react';

import type { ChildrenSnapshot } from '../types';
import { ChildrenSubscriber } from './ChildrenSubscriber';

type ChildrenSubscribersProps = {
  openedParents: Map<string, string>;
  projectId: string;
  templateNodeId: string;
  proposalId?: string;
  titlePlaceholder?: string;
  onSnapshot: (parentTreeId: string, snapshot: ChildrenSnapshot) => void;
};

/** Renders one headless `<ChildrenSubscriber />` per opened parent. */
export const ChildrenSubscribers: FC<ChildrenSubscribersProps> = ({
  openedParents,
  projectId,
  templateNodeId,
  proposalId,
  titlePlaceholder,
  onSnapshot
}) => (
  <>
    {Array.from(openedParents.entries()).map(([treeId, dataId]) => (
      <ChildrenSubscriber
        key={treeId}
        parentTreeId={treeId}
        parentDataNodeId={dataId}
        projectId={projectId}
        templateNodeId={templateNodeId}
        proposalId={proposalId}
        titlePlaceholder={titlePlaceholder}
        onSnapshot={onSnapshot}
      />
    ))}
  </>
);
